import { useEventListener } from "@vueuse/core";
import { getActivePinia } from "pinia";
import { useStore } from "../store";

function update() {
	if (!getActivePinia()) {
		return;
	}

	const { app } = useStore();
	app.setBrowser();
	// app.isFold = app.browser.isMini;
}

export function resize() {
	useEventListener(window, "resize", update);
	update();
}
